import { useEffect, useState } from 'react';
import { Outlet, useRouterState } from '@tanstack/react-router';
import { Menu } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { Button } from './ui/button';
import { useOperatorNotifications } from '@/hooks/useOperatorNotifications';

/**
 * Authenticated shell — Sidebar (off-canvas drawer on mobile, static on lg+)
 * + scrollable main area. Page-level TopBanner is mounted per-route so each
 * page controls its title, search placeholder, etc.
 */
export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { location } = useRouterState();

  // Notificaciones del navegador + refresco de la lista de chats en vivo.
  useOperatorNotifications();

  // Close the drawer automatically on route change.
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <main className="flex flex-1 flex-col overflow-hidden">
        {/* Mobile-only top bar: hamburger + brand. Desktop keeps the inline sidebar. */}
        <div className="sticky top-0 z-20 flex h-12 shrink-0 items-center gap-2 border-b border-sidebar-border bg-sidebar px-3 lg:hidden">
          <Button
            variant="ghost"
            size="icon"
            className="h-11 w-11 shrink-0 text-sidebar-foreground"
            onClick={() => setSidebarOpen(true)}
            aria-label="Abrir menú"
          >
            <Menu className="h-5 w-5" />
          </Button>
          <span className="truncate text-sm font-semibold text-sidebar-foreground">Chat Casino</span>
        </div>

        <Outlet />
      </main>
    </div>
  );
}
